import React from "react";

export default function AnalyticsHeader() {
    return (
        <>
            <div css={`
                display: flex;
                flex-direction: row;
                align-items: center;
            `}>
                <div css={`
                    width: 100%;
                `}>
                    <div css={`
                        font-size:24px;
                        color:#2E2E38;
                    `}>
                        Analytics
                    </div>
                    <div css={` 
                        font-size:16px;
                        color:#2E2E38;
                        margin-top:12px;
                        `}>
                        <span>
                            Following are the analytics of simulations.
                        </span>
                    </div>
                </div>
            </div>
        </>
    )
}